import Text from '@deprecated-ui/common/Text';
import Flex from '@deprecated-ui/common/Flex';
import BaseButton from '@deprecated-ui/common/Button';
import BaseDatePicker from '@deprecated-ui/common/DatePicker';
import AutocompleteBase from '@deprecated-ui/common/Autocomplete';
import Input from '@deprecated-ui/common/Input';
import SelectBase from '@deprecated-ui/widget/Select';
import device from '@deprecated-ui/_style/device';
import color from '@deprecated-ui/_style/color';
import { Table as BaseTable } from 'antd';
import styled from 'styled-components';
import { InfoTable } from '../DetailModal/InfoTable';

export const HistoryTable = styled(BaseTable)`
  height: 100%;
  width: 100%;
  cursor: pointer;

  .ant-spin-nested-loading,
  .ant-spin-container,
  .ant-table-empty,
  .ant-table-container,
  .ant-table-content {
    height: 100%;
  }

  & .ant-table-content > table {
    height: 100%;
  }

  .ant-table-thead > tr > th {
    height: 17px;
    font-size: 14px;
    border-bottom: 1px solid ${color.gainsboro};
    background: transparent;
  }

  .ant-table-thead > tr > th,
  .ant-table-tbody > tr > td:not(.td-mobile) {
    display: none;
  }

  .group-date-row {
    background: #f6f6f6;
  }

  .ant-table-content {
    overflow-x: auto;
  }

  @media ${device.mobileL} {
    .history-order-item {
      white-space: nowrap;
    }

    .ant-table-thead > tr > th:not(:first-child) {
      text-align: right;
    }
    .ant-table-thead > tr > th,
    .ant-table-tbody > tr > td:not(.td-mobile) {
      display: table-cell;
    }

    .ant-table-tbody > tr > td {
      padding: 8px 15px;
      height: 40px;
      border-bottom: 0;
    }

    .ant-table-tbody > tr > .td-mobile:first-child,
    .ant-table-tbody > tr > .td-mobile {
      display: table-cell;
      width: inherit;
      border-width: 1px;
    }
  }

  &.hidden-body {
    .ant-table-tbody {
      display: none;
    }
  }

  &.modal-history {
    .ant-table-thead {
      display: none;
    }
  }
`;

export const Search = styled(Input)`
  border-radius: 2px;
  padding: 0 6px 0 16px;
  width: 100%;

  &:not(.ant-input-affix-wrapper-disabled):hover {
    border-color: ${color.gainsboro};
  }

  @media ${device.tablet} {
    width: 335px !important;
  }

  input {
    font-size: 14px;
    color: ${color.nightRider};
    font-weight: 400;

    &::placeholder {
      color: ${color.gainsboro};
    }
  }

  .ant-input-prefix {
    margin-right: 10px;
  }

  .icon-toolbar_information {
    &:hover {
      color: ${color.sunsetOrange};
    }
  }

  &.has-error {
    border: 1px solid ${color.sunsetOrange};
    &:hover {
      border: 1px solid ${color.sunsetOrange};
    }
  }
`;

export const Autocomplete = styled(AutocompleteBase)`
  .ant-select-clear {
    opacity: 1;
  }
  &.ant-select-status-error {
    ${Search} {
      border-color: ${color.sunsetOrange};
    }
  }
`;

export const DatepickerContainer = styled(Flex)`
  border: 1px solid ${color.primary};
  border-radius: 4px;
`;

export const Datepicker = styled(BaseDatePicker)`
  width: 50%;
  height: 32px;
  input {
    font-size: 12px;

    &:hover {
      border: none !important;
    }
  }

  &:hover {
    border: none !important;
  }
`;

export const Button = styled(BaseButton)`
  min-width: 80px;
  border-radius: 4px;
`;

export const SellBadge = styled(Text).attrs({
  ml: '10px',
  family: 'bold',
  size: '8px',
  color: color.highgray,
})`
  padding: 3px 5px;
  border: 0.8px solid ${color.downgray};
  border-radius: 2px;
`;

export const RealizedBoxContainer = styled(Flex).attrs({
  padding: '16px',
  align: 'center',
  justify: 'center',
})`
  border-top: 1px solid ${color.gainsboro};
`;

export const RealizedBox = styled(Flex).attrs({
  direction: 'column',
  align: 'center',
  justify: 'center',
})`
  padding: 16px 12px;
  border: 1px solid ${color.gainsboro};
  border-radius: 4px;
  min-width: 280px;
  position: relative;
`;

export const RealizedTooltipBox = styled.div`
  position: absolute;
  top: -2%;
  left: 102%;
  width: 375px;
  height: auto;
  background-color: ${color.light};
  border: 1px solid ${color.gainsboro};
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;
  z-index: 999;
`;

export const Select = styled(SelectBase)`
  .ant-select-selector {
    border-radius: 4px !important;
  }

  .ant-select-selector {
    .ant-select-selection-item {
      .select-label {
        color: ${color.nightRider};
        font-family: var(--font-regular);
        display: inline;
        margin: 0;
        background: transparent;
        padding: 0;
      }
    }
  }
`;

export const CloseButton = styled(Flex).attrs({
  as: 'button',
  justify: 'center',
  align: 'center',
})`
  background: transparent;
  border: 1px solid ${color.dimGray};
  width: 16px;
  height: 16px;
  border-radius: 100%;
  cursor: pointer;
`;

export const SelectContainer = styled.div`
  .ant-select-dropdown {
    width: auto !important;

    .ant-select-item-option-selected:not(.ant-select-item-option-disabled) {
      background: ${color.component};
    }

    .ant-select-item-option-active {
      background: ${color.whisper};
      .ant-select-item-option-content {
        text-overflow: unset;
        span {
          color: ${color.primary}!important;
        }
      }
    }
  }

  .ant-picker-date-panel {
    width: 280px;
  }
`;

export const PopoverContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  border: 1px solid ${color.downgray};
  border-radius: 4px;
  padding: 20px;

  & h3 {
    font-size: 16px;
    font-weight: 700;
    line-height: 22px;
    color: ${color.highempahis};
  }

  & p {
    font-size: 14px;
    font-weight: 400;
    line-height: 19px;
    color: ${color.highempahis};
    max-width: 335px;
  }
`;

export const SellFRTooltip = styled.div`
  margin-bottom: 14px;
  padding: 12px 16px;
  display: flex;
  align-items: center;
  border-radius: 4px;
  background-color: #f2f1fe;

  & p {
    margin-bottom: 0;
    margin-left: 16px;
    font-size: 12px;
    color: ${color.highempahis};
  }
`;

export const HistoryModalInfoTable = styled(InfoTable)`
  row-gap: 8px;
`;
